export default __webpack_public_path__ + "static/media/Path1669@2x.72b84f3f.png";